"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _material = require("@mui/material");

var _classnames = _interopRequireDefault(require("classnames"));

var _BuilderThemeProvider = require("../BuilderThemeProvider");

var _BuilderBackgrounds = require("../../types/BuilderBackgrounds");

var _useBirdsColors = require("./useBirdsColors");

var ManyIcon = function ManyIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("g", {
    opacity: ".3"
  }, /*#__PURE__*/_react.default.createElement("path", {
    opacity: ".3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.332 397.573c101.889 44.635 302.21 20.946 347.391-99.494 45.182-120.44-1.613-186.021-103.502-230.407-101.889-44.386-207.928-85.53-252.879 34.91-44.95 120.44-92.899 250.605 8.99 294.991z",
    fill: "#99A1BD"
  }), /*#__PURE__*/_react.default.createElement("path", {
    opacity: ".3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M441.424 142.254C354.052 71.557 154.695 40.21 81.251 144.315 7.806 248.42 36.778 324.434 124.213 394.89c87.434 70.456 179.678 138.904 252.9 34.737 73.222-104.167 151.745-216.917 64.311-287.373z",
    fill: "#35B0F2"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M102.422 328.005V226.024l132.787 61.189v115.579l-132.787-74.787z",
    fill: "#fff",
    stroke: "#33447C",
    strokeWidth: "6",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M96.398 219.712v-50.505l138.824 67.482v52.468L96.398 219.712z",
    fill: "#fff",
    stroke: "#33447C",
    strokeWidth: "6",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M374.039 219.712v-50.505l-138.823 67.482v52.468l138.823-69.445z",
    fill: "#fff",
    stroke: "#33447C",
    strokeWidth: "6",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M368.016 328.005V226.024l-132.788 61.189v115.579l132.788-74.787zM229.186 106.075L96.398 169.207l137.77 65.95 139.877-65.95-144.859-63.132z",
    fill: "#fff",
    stroke: "#33447C",
    strokeWidth: "6",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M228.07 75.876V3M228.062 3l-41.804 43.725M228.055 3l41.804 43.725",
    stroke: "#017CBF",
    strokeWidth: "6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M397.137 344.236l60.34 36.437M457.625 380.676l-15.59-59.73M457.472 380.828l-57.105 15.702",
    stroke: "#5C6996",
    strokeWidth: "6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M81.246 344.227l-60.34 36.438M20.758 380.668l15.59-59.729M20.91 380.821l57.106 15.701",
    stroke: "#33447C",
    strokeWidth: "6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

ManyIcon.defaultProps = {
  width: "794",
  height: "796",
  viewBox: "0 0 480 484",
  xmlns: "http://www.w3.org/2000/svg"
};

var GiftRedemptionIcon = function GiftRedemptionIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("g", {
    opacity: ".3"
  }, /*#__PURE__*/_react.default.createElement("path", {
    opacity: ".3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.379 403.454c101.704 48.115 301.66 22.579 346.759-107.25 45.1-129.829-1.61-200.522-103.314-248.368C202.12-.01 96.274-44.361 51.404 85.468c-44.869 129.828-92.73 270.14 8.975 317.986z",
    fill: "#E1813D"
  }), /*#__PURE__*/_react.default.createElement("path", {
    opacity: ".3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M427.912 96.388C337.94 23.843 137.846-1.698 68.752 113.467c-69.096 115.164-37.16 195.846 52.863 268.129 90.024 72.283 184.765 142.205 253.636 26.982 68.87-115.222 142.685-239.908 52.661-312.19z",
    fill: "#E1813D"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M81 321.453v-94.211l140.898-93.06L371 230.159v91.294l-149.102 73.729L81 321.453z",
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M125.158 132.65l-.002 115.695 101.696 49.748 110.215-51.911V132.65H125.158z",
    fill: "#fff",
    stroke: "#33447C",
    strokeWidth: "6",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M80.5 321.682v-95.5l145 72v97l-145-73.5zM370.5 321.682v-91.5l-145 68v97l145-73.5z",
    stroke: "#33447C",
    strokeWidth: "6",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M111.51 116.499c-5.855-6.703-8.593-12.078-15.52-17.752-2.242-1.836-8.307-6.595-11.123-8.141M137.281 107.003c-.116-9.82-2.086-19.619-3.125-29.384M107.368 142.584c-6.211 0-12.883.646-19.104-.065-1.124-.128-11.643-.542-12.21-1.675",
    stroke: "#33447C",
    strokeWidth: "6",
    strokeLinecap: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M124.5 199.182l-43.5 27M337.5 209.182l33 21",
    stroke: "#33447C",
    strokeWidth: "6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

GiftRedemptionIcon.defaultProps = {
  width: "794",
  height: "796",
  viewBox: "0 0 481 480",
  xmlns: "http://www.w3.org/2000/svg"
};

var ProspectingIcon = function ProspectingIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("g", {
    opacity: ".3"
  }, /*#__PURE__*/_react.default.createElement("path", {
    opacity: ".3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.38 403.458c101.704 48.116 301.663 22.58 346.763-107.251 45.1-129.83-1.611-200.524-103.316-248.37C202.122-.01 96.275-44.363 51.405 85.467 6.535 215.3-41.325 355.612 60.38 403.458z",
    fill: "#6FD78A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    opacity: ".3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M427.905 96.386C337.932 23.84 137.836-1.7 68.74 113.465-.356 228.631 31.58 309.314 121.605 381.598c90.025 72.284 184.767 142.206 253.638 26.982 68.871-115.224 142.687-239.91 52.662-312.194z",
    fill: "#44ADA3"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M381.747 159.937l69.614-16.041",
    stroke: "#33447C",
    strokeWidth: "6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M368.132 217.788l65.487 22.677M406.306 81.545l-58.995 37.618",
    stroke: "#5C6996",
    strokeWidth: "6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M40.646 253.266c-1.158-11.816 13.747-23.513 19.053-26.993l9.164 39.981c-7.476.849-27.06-1.172-28.217-12.988z",
    fill: "#fff",
    stroke: "#33447C",
    strokeWidth: "6",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M207.307 150.553c20.749-10.149 57.529-54.07 64.364-69.008-2.566 30.482 5.006 79.194 14.543 109.405 9.538 30.211 30.997 66.297 40.534 80.563-15.419-2.853-51.08-13.609-70.576-11.581-22.132 2.303-46.973 15.007-78.333 21.747-38.467 12.756-103.543 20.851-113.843-42.391-11.203-68.785 102.417-68.733 143.311-88.735z",
    fill: "#fff",
    stroke: "#33447C",
    strokeWidth: "6",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M338.012 161.366c8.495 30.337 12.672 58.782 12.613 80.203-.03 10.731-1.124 19.522-3.162 25.854-2.077 6.455-4.863 9.581-7.728 10.476-2.865.894-6.813-.13-11.88-4.354-4.972-4.145-10.417-10.894-15.968-19.883-11.081-17.943-22.225-44.213-30.72-74.55-8.494-30.337-12.671-58.783-12.612-80.203.03-10.732 1.123-19.522 3.161-25.854 2.078-6.455 4.863-9.581 7.729-10.476 2.865-.894 6.812.13 11.88 4.354 4.972 4.144 10.416 10.893 15.968 19.883 11.081 17.942 22.225 44.213 30.719 74.55z",
    fill: "#fff",
    stroke: "#33447C",
    strokeWidth: "6"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M345.76 156.987c-8.952-25.905-55.734-18.342-71.758-11.487 0 0 .5 12 9 39s11.5 32 11.5 32c17.129-7.147 60.209-33.608 51.258-59.513zM133.076 334.346c3.798-11.172.21-32.684-1.372-39.845 19.669-6.446 60.344-16.814 60.886-11.085.679 7.162-18.48 48.782-18.819 65.612-.339 16.83 25.096 46.909 8.478 60.874-16.617 13.965-45.443-4.655-56.973-26.14-11.531-21.485 3.052-35.45 7.8-49.416z",
    fill: "#fff",
    stroke: "#33447C",
    strokeWidth: "6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

ProspectingIcon.defaultProps = {
  width: "794",
  height: "796",
  viewBox: "0 0 480 481",
  xmlns: "http://www.w3.org/2000/svg"
};
var styles = {
  root: {
    position: 'absolute',
    top: 0,
    right: 0,
    transform: 'translate(25%, -10%)',
    pointerEvents: 'none',
    zIndex: 0
  }
};

var BirdsBackground = function BirdsBackground(_ref) {
  var _ref$theme = _ref.theme,
      propsTheme = _ref$theme === void 0 ? 'chambray' : _ref$theme,
      className = _ref.className,
      _ref$sx = _ref.sx,
      sx = _ref$sx === void 0 ? [] : _ref$sx,
      boxProps = (0, _objectWithoutProperties2.default)(_ref, ["theme", "className", "sx"]);

  var _useBuilderTheme = (0, _BuilderThemeProvider.useBuilderTheme)(),
      _useBuilderTheme$them = _useBuilderTheme.theme,
      theme = _useBuilderTheme$them === void 0 ? propsTheme : _useBuilderTheme$them,
      background = _useBuilderTheme.background;

  var colors = (0, _useBirdsColors.useBirdsColors)(theme);

  var defaultSVG = /*#__PURE__*/_react.default.createElement("svg", {
    width: "1013px",
    height: "796px",
    viewBox: "0 0 1013 796",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, "[]", /*#__PURE__*/_react.default.createElement("title", null, "Group 2"), /*#__PURE__*/_react.default.createElement("g", {
    id: "SWAG-SELECT-/-Gift-Codes-Campaign",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react.default.createElement("g", {
    id: "SWAG---Details---Default",
    transform: "translate(-736.000000, 7.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/_react.default.createElement("g", {
    id: "Group-2",
    transform: "translate(736.000000, -7.000000)"
  }, /*#__PURE__*/_react.default.createElement("g", {
    id: "Alyce_Hummingbird_Silhouette-08",
    fill: colors.primary,
    opacity: "0.08"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M288.401904,0 C353.832841,79.1173633 419.281587,158.19912 484.58786,237.423303 C487.971605,241.518036 489.59224,241.909706 493.634925,238.010808 C541.274488,192.114192 598.513201,166.406389 663.855093,157.949876 C676.642086,156.294179 689.429079,155.457429 702.322927,155.457429 C798.456895,155.510839 894.608672,155.510839 990.74264,155.439626 C997.456702,155.439626 1003.6543,156.507817 1008.33811,161.617332 C1013.28907,167.029501 1014.23295,173.474255 1011.47253,180.168253 C1008.08878,188.339916 1001.12539,191.330851 992.861933,191.455474 C977.848792,191.651309 962.817842,191.43767 947.804701,191.526686 C921.340255,191.686915 895.231994,194.660047 869.551152,201.193817 C808.394419,216.771606 764.049554,253.642006 734.201364,308.547035 C717.905962,338.509799 706.223138,370.573339 692.848442,401.835735 C653.543576,493.735787 614.737367,585.831674 575.396882,677.713922 C559.991939,713.711966 532.405515,738.689838 499.013298,757.614625 C457.838468,780.954604 413.173038,792.402053 366.085559,795.357382 C328.419137,797.707403 291.696603,793.755095 255.971382,781.132636 C250.040924,779.03186 248.633999,777.180328 251.340995,770.967016 C267.244595,734.470482 282.667347,697.760311 298.232573,661.121352 C299.194269,658.842544 300.066919,656.528129 301.171088,653.750832 C281.776888,656.047443 262.9882,658.09481 244.146085,657.329273 C132.945549,652.807263 52.4658521,600.946579 3.52621817,500.785849 C2.42204884,498.507041 1.17540606,496.299446 0,494.056244 C0,493.201691 0,492.347138 0,491.474782 C1.95901009,489.000139 4.79067013,487.985357 7.58671181,486.863757 C39.2336294,474.152281 70.8449286,461.369593 102.420609,448.444479 C109.045625,445.738395 109.294954,445.239905 104.237146,440.504258 C82.8305085,420.493475 66.0898768,396.993268 52.6973715,371.125238 C38.2897427,343.281053 28.9933494,313.763369 25.2178026,282.554382 C23.6684037,269.771694 22.2080508,257.024612 22.7601354,244.135104 C24.0958241,213.104149 29.0111585,182.785322 40.658364,153.801733 C44.362674,144.597485 45.6983627,143.938767 55.0838019,147.873272 C96.2052047,165.160166 137.290989,182.55388 178.412392,199.840775 C179.801508,200.42828 181.172815,201.033588 182.561931,201.60329 C189.810269,204.576423 189.828078,204.576423 190.166452,197.063478 C192.463837,145.843708 206.693374,98.3982149 235.223684,55.5103373 C247.761349,36.6567622 263.023819,20.1532078 279.479503,4.70004138 C281.72346,2.58146212 284.590739,1.60228684 287.119643,0.0178031871 C287.547063,0 287.974483,0 288.401904,0 Z",
    id: "Path"
  })), /*#__PURE__*/_react.default.createElement("g", {
    id: "Alyce_Hummingbird_Silhouette-07",
    transform: "translate(310.000000, 266.000000)",
    opacity: "0.08",
    fill: colors.secondary
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M185.909618,0 C228.087705,50.988954 270.277272,101.954961 312.374998,153.012757 C314.556227,155.651699 315.600921,155.904119 318.206916,153.391387 C348.916329,123.812287 385.813544,107.244319 427.93423,101.794329 C436.176981,100.727279 444.419732,100.188017 452.731364,100.188017 C514.701236,100.222438 576.682589,100.222438 638.652462,100.176543 C642.98048,100.176543 646.975574,100.864963 649.994854,104.157904 C653.186337,107.645897 653.794785,111.799363 652.015362,116.11346 C649.834132,121.37987 645.345392,123.307446 640.0186,123.387761 C630.34083,123.513972 620.65158,123.376288 610.97381,123.433656 C593.914301,123.536919 577.084395,125.45302 560.530012,129.663854 C521.107162,139.703309 492.521578,163.465263 473.28084,198.850036 C462.776499,218.16021 455.245517,238.824275 446.623922,258.972025 C421.287221,318.199069 396.271965,377.552322 370.912304,436.767892 C360.981971,459.967636 343.199212,476.065184 321.673923,488.261687 C295.131806,503.303658 266.339579,510.681223 235.986051,512.58585 C211.705525,514.100374 188.033447,511.553221 165.004257,503.418395 C161.181366,502.064502 160.274434,500.871242 162.019417,496.866934 C172.271195,473.345926 182.213009,449.687235 192.246663,426.074439 C192.866592,424.60581 193.429119,423.114234 194.140889,421.324343 C181.639001,422.804445 169.527438,424.123916 157.381435,423.630549 C85.6993516,420.716239 33.8205345,387.293461 2.27307054,322.742639 C1.56130098,321.27401 0.757690182,319.851276 0,318.405595 C0,317.854859 0,317.304123 0,316.741914 C1.26281697,315.147075 3.0881615,314.493076 4.89054572,313.770235 C25.2907798,305.57804 45.6680537,297.339951 66.0223672,289.010072 C70.2929846,287.266076 70.4537067,286.944813 67.1933429,283.892819 C53.3941975,270.996423 42.6028525,255.851189 33.9697765,239.179958 C24.6823317,221.235151 18.6896911,202.211819 16.2558984,182.09849 C15.257125,173.860401 14.3157524,165.645259 14.6716372,157.338327 C15.5326487,137.339734 18.7011713,117.800088 26.2091922,99.1209661 C28.5970643,93.1890829 29.4580758,92.7645574 35.5081171,95.3002367 C62.0157933,106.441163 88.5005092,117.65093 115.008185,128.791856 C115.903637,129.170487 116.787609,129.560591 117.683061,129.927749 C122.355484,131.84385 122.366964,131.84385 122.585087,127.001965 C124.066027,93.9922392 133.23867,63.41493 151.629878,35.7748782 C159.711906,23.6242701 169.550398,12.9881854 180.158061,3.02904677 C181.60456,1.66368099 183.452865,1.03262958 185.083047,0.011473662 C185.358571,0 185.634094,0 185.909618,0 Z",
    id: "Path"
  }))))));

  var backgroundSVG = function backgroundSVG() {
    switch (background) {
      case _BuilderBackgrounds.BuilderBackground.ONE_TO_MANY:
        return /*#__PURE__*/_react.default.createElement(ManyIcon, null);

      case _BuilderBackgrounds.BuilderBackground.GIFT_REDEMPTION:
      case _BuilderBackgrounds.BuilderBackground.CUSTOM_KIT:
        return /*#__PURE__*/_react.default.createElement(GiftRedemptionIcon, null);

      case _BuilderBackgrounds.BuilderBackground.PROSPECTING:
        return /*#__PURE__*/_react.default.createElement(ProspectingIcon, null);

      default:
        return defaultSVG;
    }
  };

  return /*#__PURE__*/_react.default.createElement(_material.Box, (0, _extends2.default)({
    className: (0, _classnames.default)(className),
    sx: [styles.root].concat((0, _toConsumableArray2.default)(Array.isArray(sx) ? sx : [sx]))
  }, boxProps), backgroundSVG());
};

var _default = BirdsBackground;
exports.default = _default;